import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.17647,1077.91059 C1694.17647,1401.14824 1224.00235,1657.97647 1023.30588,1767.64235 C997.442353,1781.76 975.870588,1793.50588 960.058824,1802.88 C944.247059,1793.50588 922.675294,1781.76 896.811765,1767.64235 C696.115294,1657.97647 225.941176,1401.14824 225.941176,1077.91059 L225.941176,437.534118 L960.058824,122.88 L1694.17647,437.534118 L1694.17647,1077.91059 Z M960.058824,0 L113,362.992941 L113,1077.91059 C113,1468.12235 624.397647,1747.53882 842.712941,1866.80471 C870.157647,1881.82588 892.407059,1893.91059 907.654118,1903.05882 L907.654118,1903.17176 C923.804706,1912.88471 941.875294,1917.74118 960.058824,1917.74118 C978.129412,1917.74118 996.312941,1912.88471 1012.46353,1903.05882 C1027.71059,1893.91059 1049.96,1881.82588 1077.40471,1866.80471 C1295.72,1747.53882 1807.11765,1468.12235 1807.11765,1077.91059 L1807.11765,362.992941 L960.058824,0 Z M604.689412,868.562824 L524.84,948.412235 L847.061176,1270.74635 L1451.74824,666.059294 L1371.89882,586.209882 L847.061176,1110.93459 L604.689412,868.562824 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStandardsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconStandardsLine, _Component);

  var _super = _createSuper(IconStandardsLine);

  function IconStandardsLine() {
    _classCallCheck(this, IconStandardsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconStandardsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStandards",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStandardsLine.displayName = "IconStandardsLine";
  return IconStandardsLine;
}(Component);

IconStandardsLine.glyphName = 'standards';
IconStandardsLine.variant = 'Line';
IconStandardsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStandardsLine;
export { IconStandardsLine };